import { FillRows } from "../AnswerFill.typings";

export const getIsValidArea = (id: string | undefined, rows: FillRows) => {
    return rows.some((row) => row.id === id);
};
